import { F as u, j as T } from "./colors-cfab1b7b.js";
const g = (o) => (o == null ? void 0 : o.type) === "PLAY_ADS", r = (o) => o === u.ADS, h = (o, n) => {
  const d = n == null ? void 0 : n.findIndex(
    (A) => A.start === (o == null ? void 0 : o.start) && A.end === (o == null ? void 0 : o.end)
  );
  if (!(d === -1 || d === void 0))
    return n == null ? void 0 : n[d + 1];
}, p = (o, n) => Number((o == null ? void 0 : o.end) || 0) - Math.round(n || 0), S = (o) => {
  if (!o)
    return 0;
  if ((o == null ? void 0 : o.type) === "PLAY_CONTENT" && o.start > 0) {
    const d = o.start - T;
    return d > 0 ? d : 0;
  }
  return o == null ? void 0 : o.start;
}, _ = (o) => {
  var n, d;
  return r((n = o == null ? void 0 : o[0]) == null ? void 0 : n.type) && ((d = o == null ? void 0 : o[0]) == null ? void 0 : d.start) === 0;
}, N = (o) => o == null ? void 0 : o.some((n) => n.type === u.ADS);
export {
  r as a,
  p as b,
  S as c,
  N as d,
  h as g,
  _ as h,
  g as i
};
//# sourceMappingURL=avod-d6b845d4.js.map
